
export type InvalidateSession200 = {
  message?: string;
  success?: boolean;
};
